angular.module('unica_workshop.workshop_services')

.factory('WorkshopCreateService', function ($http, getBaseApiURL) {

	var workshopCreateService = {};

	workshopCreateService.create = function ( workshopData) {

		return $http({
			method: 'POST',
			url: getBaseApiURL + '/workshop/create',
			data: workshopData
		}).then(function(result) {

			if ( result ) {
				return result.data.workshop;
			}

		});
 
	};

	return workshopCreateService;
});